import {
  ExceptionFilter,
  Catch,
  ArgumentsHost,
  UnauthorizedException,
} from '@nestjs/common';
import { Response } from 'express';

@Catch(UnauthorizedException)
export class UnauthorizedExceptionFilter implements ExceptionFilter {
  catch(exception: UnauthorizedException, host: ArgumentsHost) {
    console.log('error', exception);

    const ctx = host.switchToHttp();
    const response = ctx.getResponse<Response>();

    response
      .status(401)
      .json(['Session Expired. Please login again to continue']);
  }
}
